import axios from 'axios';
import { getApiUrl } from './api';

const CHUNK = 1024 * 1024; // 1 Mo : passe sous les limites de corps de requête des proxys (prod : Cloudflare 520 sur 7 Mo d'un bloc)
export const CHUNK_MIN_SIZE = 900 * 1024;

/** Envoie un fichier par morceaux puis lance la lecture. Renvoie { job_id, file_ref }. onProgress(0..1). */
export async function uploadScanInChunks(file, { pageStart = 0, onProgress, kind = 'scan' } = {}) {
  const uploadId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append('index', String(i)); fd.append('total', String(total));
    fd.append('chunk', file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK)), `part-${i}`);
    let tries = 0;
    for (;;) {
      try { await axios.post(`${getApiUrl()}/fiches-techniques/scan/upload/${uploadId}/chunk`, fd, { withCredentials: true, timeout: 60000 }); break; }
      catch (e) { if (++tries >= 3 || [401, 403, 413, 422].includes(e?.response?.status)) throw e; await new Promise(r => setTimeout(r, 800 * tries)); }
    }
    onProgress?.((i + 1) / total);
  }
  const fd = new FormData(); fd.append('filename', file.name || 'document.pdf'); fd.append('page_start', String(pageStart)); fd.append('kind', kind);
  const { data } = await axios.post(`${getApiUrl()}/fiches-techniques/scan/upload/${uploadId}/finish`, fd, { withCredentials: true, timeout: 120000 });
  return data;
}

/** Même principe pour les factures (Fournisseurs & Achats) : renvoie le lot créé (batch). */
export async function uploadIntakeInChunks(file, { onProgress } = {}) {
  const uploadId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append('index', String(i)); fd.append('total', String(total));
    fd.append('chunk', file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK)), `part-${i}`);
    let tries = 0;
    for (;;) {
      try { await axios.post(`${getApiUrl()}/factures/intake/upload/${uploadId}/chunk`, fd, { withCredentials: true, timeout: 60000 }); break; }
      catch (e) { if (++tries >= 3 || [401, 403, 413, 422].includes(e?.response?.status)) throw e; await new Promise(r => setTimeout(r, 800 * tries)); }
    }
    onProgress?.((i + 1) / total);
  }
  const fd = new FormData(); fd.append('filename', file.name || 'document.pdf');
  const { data } = await axios.post(`${getApiUrl()}/factures/intake/upload/${uploadId}/finish`, fd, { withCredentials: true, timeout: 120000 });
  return data;
}
